import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"src/app/fonts.ts\",\"import\":\"\",\"arguments\":[{\"variable\":\"--font-urbanist\",\"display\":\"swap\",\"src\":[{\"path\":\"../../public/fonts/urbanist/Urbanist-VariableFont_wght.ttf\",\"weight\":\"100 900\",\"style\":\"normal\"},{\"path\":\"../../public/fonts/urbanist/Urbanist-Italic-VariableFont_wght.ttf\",\"weight\":\"100 900\",\"style\":\"italic\"}]}],\"variableName\":\"urbanist\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/footer/copy-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/src/components/navbar/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/src/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConsentDefaults"] */ "/vercel/path0/src/lib/scripts/consent-defaults.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/lib/scripts/cookie-hub.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTagManagerNoScript"] */ "/vercel/path0/src/lib/scripts/google-tag-manager-noscript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GtmPageviewTracker"] */ "/vercel/path0/src/lib/scripts/google-tag-manager-page-view-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GoogleTagManager"] */ "/vercel/path0/src/lib/scripts/google-tag-manager.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["TRPCReactProvider"] */ "/vercel/path0/src/trpc/react.tsx");
